<template>
  <div class='container-fluid'>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdminMailboxesIndex from './mailboxes/Index'
import AdminTeamsIndex from './teams/Index'
import AdminJotformsIndex from './jotforms/Index'
import AdminUsersIndex from './users/Index'
import AdminClients from './Clients'
import AdminTags from './Tags'
import AdminReportsIndex from './reports/Index'
export default {
  name: 'AdminIndex',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  created () {
    this.checkAdmin()
  },
  methods: {
    checkAdmin () {
      if (!this.currentUser.roles.includes('admin') && process.env.NODE_ENV === 'production') {
        this.$router.push('/boards')
      }
    }
  },
  components: {
    AdminReportsIndex,
    AdminMailboxesIndex,
    AdminTeamsIndex,
    AdminJotformsIndex,
    AdminUsersIndex,
    AdminClients,
    AdminTags
  }
}
</script>

<style>
.admin-nav {
  margin: 10px 0px 0px 10px;
}
.admin-head {
  right: 0;
  position: fixed;
  padding: 0.5rem 1rem;
  display: block;
  background: #434343;
  color: white;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.admin-sub-nav {
  margin: 20px 0px;
}
.admin-form {
  background-color: #FAFAFA;
  padding: 20px 10px;
  border-radius: 10px;
}
.admin-page{
  margin-top: 20px;
}
.col-form-label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue